import { common as frCommon } from './fr/common';
import { common as enCommon } from './en/common';
import { common as arCommon } from './ar/common';

export default {
  fr: { common: frCommon },
  en: { common: enCommon },
  ar: { common: arCommon },
};